import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServicesDataConfiguration } from '../../data-config/services-data-config';
import { LocalStorageService } from '../global/local-storage.service';
import { AdminServiceDataConfiguration } from 'src/app/data-config/admin-service-data-config';

const httpOptions = {
    params: new HttpParams().set('t', new Date().getTime()).set('ts', new Date().getTime())
};


@Injectable({
    providedIn: 'root'
})

export class AdminApproveRegistrationService {
  constructor(
      private http: HttpClient,
      private localStorageService: LocalStorageService
  ) { }

    _adminServicesDataConfiguration = new AdminServiceDataConfiguration();

    getRegistrationAccountAllData(x_csrf_token:string, page: number, size: number, searchType: string, searchValue: string): Observable<any> {
      let lang = this.localStorageService.get('lang');
      let s_url = this._adminServicesDataConfiguration.registrationAccountAllData.replace(
        'LANG_AUTH', 
        lang);

      const httpOptionsAcc = {
        params: new HttpParams()
          .set('page', page.toString())
          .set('size', size.toString())
          .set('searchType', searchType)
          .set('searchValue', searchValue)
          .set('t', new Date().getTime().toString())
          .set('ts', new Date().getTime().toString()),
      }

      return this.http.get(
        this._adminServicesDataConfiguration.apiBaseURL + s_url,
        httpOptionsAcc 
      );
    }

    setRegistrationAccountDecision(data: any, x_csrf_token:string): Observable<any> {
      let lang = this.localStorageService.get('lang');
      let s_url = this._adminServicesDataConfiguration.setRegistrationAccountDecision.replace(
        'LANG_AUTH', 
        lang);
      return this.http.post(
        this._adminServicesDataConfiguration.apiBaseURL + s_url, 
        data, 
        httpOptions);
    }
}